import { render, staticRenderFns } from "./internalExternalIssuesDetail.vue?vue&type=template&id=8b3471a6"
import script from "./internalExternalIssuesDetail.vue?vue&type=script&lang=js"
export * from "./internalExternalIssuesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3471a6')) {
      api.createRecord('8b3471a6', component.options)
    } else {
      api.reload('8b3471a6', component.options)
    }
    module.hot.accept("./internalExternalIssuesDetail.vue?vue&type=template&id=8b3471a6", function () {
      api.rerender('8b3471a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iei/internalExternalIssuesDetail.vue"
export default component.exports